import { cn } from "~/shared/lib/utils";
import { getBrand } from "~/tenant";
import { ResponsiveImage } from "./responsive-image";

interface LogoProps {
  className?: string;
  alt?: string;
  priority?: boolean;
}

const logoSources = {
  qc: "/quadball-canada-logo.svg",
} as const;

export function Logo({ className, alt, priority = false }: LogoProps) {
  const brand = getBrand();
  const src = logoSources.qc;

  return (
    <ResponsiveImage
      src={src}
      alt={alt ?? `${brand.name} logo`}
      loading={priority ? "eager" : "lazy"}
      className={cn("object-contain", className)}
    />
  );
}
